module.exports = __webpack_public_path__ + "static/media/Eyes_violet.27f1cb22.svg";